import axios from 'axios'
import Vue from 'vue'
import router from '@/router'

const PRE_HTTP_API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' }
})
/*
* The interceptor here ensures that we check for the token in local storage every time an ajax request is made
*/
PRE_HTTP_API.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('pre-web-token')
     var currentDate = new Date();
    if (currentDate.getTime() < sessionStorage.getItem('expDate')) {
      config.headers['Authorization'] = `Bearer ${ token }`
    } else {
      setTimeout(() => {
        window.location.href = "/CR/"
      }, 1000)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

PRE_HTTP_API.interceptors.response.use(
  (response) => {
    console.log(response)
    return response
  },
  (error) => {
    if (error == 'Error: Network Error')
      router.push({ name: 'login' })
    return Promise.reject(error)
  }
)

export default PRE_HTTP_API
